import React, { useEffect, useState } from "react";
import { Shell, KpiCard, Section } from "@/components/loomi/Layout";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { LayoutDashboard, FolderKanban, Plus, Settings, UserCircle } from "lucide-react";
import { ProjectsTable } from "../admin/AdminDashboard";

export const PM_NAV = [
  { to: "/pm", label: "Overview", icon: LayoutDashboard, testId: "nav-pm-overview" },
  { to: "/pm/projects", label: "My projects", icon: FolderKanban, testId: "nav-pm-projects", match: "/pm/projects" },
  { to: "/pm/new", label: "Create ad-hoc", icon: Plus, testId: "nav-pm-new" },
  { to: "/pm/settings", label: "Settings", icon: Settings, testId: "nav-pm-settings" },
  { to: "/pm/profile", label: "Profile", icon: UserCircle, testId: "nav-pm-profile" },
];

export default function PmDashboard() {
  const [kpis, setKpis] = useState(null);
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    (async () => {
      const [k, p] = await Promise.all([api.get("/pm/kpis"), api.get("/projects", { params: { mine: true } })]);
      setKpis(k.data); setProjects(p.data);
    })();
  }, []);

  return (
    <Shell title="PM Overview" portalLabel="PM" nav={PM_NAV}>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        <KpiCard label="Projects" value={kpis?.projects ?? "—"} accent="primary" testId="pm-kpi-projects" />
        <KpiCard label="Live" value={kpis?.live ?? "—"} accent="green" testId="pm-kpi-live" />
        <KpiCard label="Starts" value={kpis?.starts ?? "—"} accent="blue" testId="pm-kpi-starts" />
        <KpiCard label="Completes" value={kpis?.complete ?? "—"} accent="green" testId="pm-kpi-complete" />
        <KpiCard label="Terminates" value={kpis?.terminate ?? "—"} accent="red" testId="pm-kpi-terminate" />
      </div>

      <div className="mt-8">
        <Section title="My projects" action={<Link to="/pm/new" className="text-xs bg-indigo-500 hover:bg-indigo-400 px-3 py-1.5 rounded-md inline-flex items-center gap-1.5" data-testid="pm-new-link"><Plus className="w-3.5 h-3.5" />New ad-hoc</Link>} testId="section-pm-projects">
          <ProjectsTable projects={projects} basePath="/pm/projects" />
        </Section>
      </div>
    </Shell>
  );
}
